<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data">
      <template #suffix>
        <b-button class="mr-2" variant="success" @click="exportMonthlyDeceasedClaimsReport()">匯出每月身故理賠人數報表</b-button>
      </template>
    </bread-crumb>

    <div class="operate">
      <div class="search">
        <b-form-checkbox
          class="mb-2"
          switch
          size="lg"
          value=1
          unchecked-value=0
          v-model.number="search.plan"
          @change="getReportMonthPay(1)"
        >
          是否分組
        </b-form-checkbox>

        <date-picker
          v-model="search.date_S"
          :position="'right'"
          placeholder="開始日期"
        ></date-picker>

        <date-picker
          v-model="search.date_E"
          :position="'right'"
          placeholder="結束日期"
        ></date-picker>
      </div>

      <div class="btn-area">
        <div class="btn-function">
          <b-button variant="danger" @click="resetSearch()">重置</b-button>

          <b-button variant="success" @click="getReportMonthPay(1)">搜尋</b-button>
        </div>
      </div>
    </div>

    <tables-page
      :tableData="data.table_data"
      :tableFields="tableFields"
      :pageData="data.page"
      v-on:result="getReportMonthPay"
    >
      <template #cell(year_month)="row">
        <span v-if="search.plan">
          {{ Number(row.item.month.split('-')[0]) - 1911 }}-{{ row.item.month.split('-')[1] }}
        </span>

        <span
          v-else
          class="link"
          @click="openContractModal(row.item)"
        >
         {{ Number(row.item.month.split('-')[0]) - 1911 }}-{{ row.item.month.split('-')[1] }}
        </span>
      </template>

      <template #cell(consolation_money)="row">
        {{ Thousands(row.item.consolation_money) }}
      </template>

      <template #cell(bar_chart)="row">
        <b-progress :value="row.item.count" :max="data.bar_max_value" show-value></b-progress>
      </template>

      <template #custom-foot>
        <tr>
          <td class="text-center">全部加總金額</td>

          <td class="text-center" colspan="3">{{ Thousands(data.sum_total) }}</td>
        </tr>
      </template>
    </tables-page>

    <!-- 契約 modal -->
    <monthly-deceased-claims-contract-modal
      v-model="status.contractModal"
      :data="data.temp_table_data" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import reportApi from "@/models/API/reportApi";
import TablesPage from "@/components/layouts/TablesPage";
import MonthlyDeceasedClaimsContractModal from"./components/modal/MonthlyDeceasedClaimsContractModal";
import { downloadFile, Thousands } from "@/models/HELPERS/common.js";
import datePicker from '@/components/common/DatePicker';

export default {
  name: 'monthlyDeceasedClaimsReport',
  components: {
    BreadCrumb,
    TablesPage,
    MonthlyDeceasedClaimsContractModal,
    datePicker
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '報表', url: '', isActive: true },
          { name: '每月身故理賠人數', url: '', isActive: false }
        ]
      },
      status: {
        contractModal: false
      },
      search: {
        plan: 0,
        date_S: '',
        date_E: ''
      },
      data: {
        table_data: [],
        page: {},
        temp_table_data: {},
        bar_max_value: 100,
        sum_total: 0
      },
    }
  },
  computed: {
    tableFields() {
      let fields = [
        {
          key: "year_month",
          label: "年月",
        },
        {
          key: "count",
          label: "人數",
        },
        {
          key: "consolation_money",
          label: "加總理賠實發慰問金",
        },
        {
          key: "bar_chart",
          label: "長條圖",
        }
      ];

      if (this.search.plan) {
        fields.unshift({
          key: "plan",
          label: "組別",
        })
      }

      return fields;
    }
  },
  mounted() {
    this.reportApi = new reportApi();
    this.load();
  },
  methods: {
    Thousands,
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.reportApi.page);
      this.getReportMonthPay();
    },
    // 取得每月身故理賠人數
    getReportMonthPay(pageIndex = null) {
      const params = {
        ...this.search,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };

      this.reportApi.getReportMonthPay((response) => {
        const res = response.data;

        this.data.bar_max_value = Math.max(...res.data.map(item => item.count));
        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data.map(item => {
          return {
            ...item,
            consolation_money: item.total_claim_pay
          }
        });
        this.data.sum_total = res.sum_total_claim_pay;
      }, params)
    },
    // 開啟契約 modal
    openContractModal(item = null) {
      this.status.contractModal = true;
      this.data.temp_table_data = Object.assign({}, item);
    },
    // 匯出每月身故理賠人數報表
    exportMonthlyDeceasedClaimsReport() {
      const params = {
        ...this.search,
        type: 2
      };

      this.reportApi.exportReportMonth((response) => {
        if (!response) return;

        downloadFile(response);
      }, params)
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        plan: 0,
        date_S: '',
        date_E: ''
      }

      this.getReportMonthPay(1);
    },
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
    .blur {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 10px;
      .blur-info {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        font-size: 12px;
        background: #17A2B8;
        color: #FFF;
      }
    }
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/monthlyDeceasedClaimsReport.vue